import { type TickPayload } from '#/types/messages';

export const isTickPayload = (messagePayload: unknown): messagePayload is TickPayload => {
  if (!messagePayload || typeof messagePayload !== 'object') return false;

  if (!('type' in messagePayload && messagePayload.type === 'tickMessage')) return false;

  //@todo Need to add logs for incorrect data

  if (!('data' in messagePayload && typeof messagePayload.data === 'object' && messagePayload.data)) return false;

  if (!('symbol' in messagePayload.data && typeof messagePayload.data.symbol === 'string')) return false;

  if (!(
    'time' in messagePayload.data &&
    typeof messagePayload.data.time === 'object' &&
    messagePayload.data.time !== null &&
    'raw' in messagePayload.data.time &&
    typeof messagePayload.data.time.raw === 'number' &&
    'second' in messagePayload.data.time &&
    typeof messagePayload.data.time.second === 'number'
  ))
    return false;

  if (!('bid' in messagePayload.data && typeof messagePayload.data.bid === 'number')) return false;

  if (!('ask' in messagePayload.data && typeof messagePayload.data.ask === 'number')) return false;

  return true;
};
